module.exports = __webpack_public_path__ + "2661e59a174c43400cecb47a7fbb1194.otf";